module.exports = __webpack_public_path__ + "img/335549005.68234519.jpg";